<template>
  <v-container fluid fill-height justify-center>
    <v-col>
      <!-- Sezione Certificazioni -->
      <v-row no-gutters class="mt-3">
        <!-- Tipo di Certificazione -->
        <v-col class="mt-5" cols="2">
          <span style="font-size: 17px">Tipo di Certificazione:</span>
        </v-col>
        <v-col cols="2">
          <v-checkbox :disabled="cliente.certificazioneFSCG" v-model="cliente.certificazioneFSCS" label="FSC (singola)"
            color="primary" hide-details @change="notificaAggiornamento" />
          <v-checkbox :disabled="cliente.certificazioneFSCS" v-model="cliente.certificazioneFSCG" label="FSC (gruppo)"
            color="primary" hide-details @change="notificaAggiornamento" />
          <v-checkbox :disabled="cliente.certificazionePEFCG" v-model="cliente.certificazionePEFC"
            label="PEFC (singola)" color="primary" hide-details @change="notificaAggiornamento" />
          <v-checkbox :disabled="cliente.certificazionePEFC" v-model="cliente.certificazionePEFCG" label="PEFC (gruppo)"
            color="primary" hide-details @change="notificaAggiornamento" />
          <v-checkbox v-model="cliente.certificazioneFPC" label="FPC" color="primary" hide-details
            @change="notificaAggiornamento" />
          <v-checkbox v-model="cliente.certificazioneISO" label="ISO" color="primary" hide-details
            @change="notificaAggiornamento" />
        </v-col>

        <!-- Codici Certificazione -->
        <v-col class="mt-3" cols="5">
          <v-text-field :disabled="!cliente.certificazioneFSCS" class="mb-5" v-model="cliente.codiceFSCS" dense
            hide-details label="Codice certificazione FSC (singola)" clearable />
          <v-text-field :disabled="!cliente.certificazioneFSCG" class="mb-5" v-model="cliente.codiceFSCG" dense
            hide-details label="Codice certificazione FSC (gruppo)" clearable />
          <v-text-field :disabled="!cliente.certificazionePEFC" class="mb-5" v-model="cliente.codicePEFC" dense
            hide-details label="Codice certificazione PEFC singola" clearable />
          <v-text-field :disabled="!cliente.certificazionePEFCG" class="mb-5" v-model="cliente.codicePEFCG" dense
            hide-details label="Codice certificazione PEFC gruppo" clearable />
          <v-text-field :disabled="!cliente.certificazioneFPC" class="mb-4" v-model="cliente.codiceFPC" dense
            hide-details label="Codice certificazione FPC" clearable />
          <v-text-field :disabled="!cliente.certificazioneISO" v-model="cliente.codiceISO" dense hide-details
            label="Codice certificazione ISO" clearable />
        </v-col>

        <!-- Date Audit -->
        <v-col cols="3">
          <v-row no-gutters>
            <v-col class="ma-0 pa-0 ml-16">
              <!-- Data Audit FSC Singola -->
              <campo-data :disabled="!cliente.certificazioneFSCS" v-model="cliente.dataAuditFSCS"
                label="Data Audit FSC (singola)" class-custom="ml-3 mt-4" />

              <!-- Data Audit FSC Gruppo -->
              <campo-data :disabled="!cliente.certificazioneFSCG" v-model="cliente.dataAuditFSCG"
                label="Data Audit FSC (gruppo)" class-custom="ml-3 mt-4" />

              <!-- Data Audit PEFC Singola -->
              <campo-data :disabled="!cliente.certificazionePEFC" v-model="cliente.dataAuditPEFC"
                label="Data Audit PEFC (singola)" class-custom="ml-3 mt-4" />

              <!-- Data Audit PEFC Gruppo -->
              <campo-data :disabled="!cliente.certificazionePEFCG" v-model="cliente.dataAuditPEFCG"
                label="Data Audit PEFC (gruppo)" class-custom="ml-3 mt-3" />

              <!-- Data Audit FPC -->
              <campo-data :disabled="!cliente.certificazioneFPC" v-model="cliente.dataAuditFPC" label="Data Audit FPC"
                class-custom="ml-3 mt-4" />

              <!-- Data Audit ISO -->
              <campo-data :disabled="!cliente.certificazioneISO" v-model="cliente.dataAuditISO" label="Data Audit ISO"
                class-custom="ml-3 mt-3" />
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <!-- Responsabili -->
      <v-row no-gutters class="mt-3">
        <v-col cols="6">
          <v-text-field v-model="cliente.respCoc" class="mr-10" hide-details dense label="Responsabile Coc" clearable />
        </v-col>
        <v-col cols="6">
          <v-text-field v-model="cliente.respFPC" dense hide-details label="Responsabile FPC" clearable />
        </v-col>
      </v-row>

    </v-col>
  </v-container>
</template>

<script>
import CampoData from "./CampoData.vue";

export default {
  name: "DatiCertificazioni",

  components: {
    CampoData,
  },

  props: {
    cliente: {
      type: Object,
      required: true,
    },
  },

  methods: {
    notificaAggiornamento() {
      this.$emit("update");
    },
  },
};
</script>
